/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum VitalSignCreateAndEditAliases {
  ABDOMINAL_FIELD = 'abdominal-field',
  ABDOMINAL_INPUT = 'abdominal-input',
  ALTERATION_AUTOCOMPLETE = 'alteration-autocomplete',
  ALTERATION_FIELD = 'alteration-field',
  ALTERATION_MAPPER = 'alteration-mapper',
  ALTERATION_TEXT = 'alteration-text',
  ARM_CIRCUMFERENCE_FIELD = 'arm-circumference-field',
  ARM_CIRCUMFERENCE_INPUT = 'arm-circumference-input',
  BABINSKI_AUTOCOMPLETE = 'babinski-autocomplete',
  BABINSKI_FIELD = 'babinski-field',
  BABINSKI_MAPPER = 'babinski-mapper',
  BLOOD_GLUCOSE_CONTROL_AUTOCOMPLETE = 'blood-glucose-control-autocomplete',
  BLOOD_GLUCOSE_CONTROL_FIELD = 'blood-glucose-control-field',
  BLOOD_GLUCOSE_CONTROL_MAPPER = 'blood-glucose-control-mapper',
  BLOOD_GLUCOSE_CONTROL_TEXT = 'blood-glucose-control-text',
  BLOOD_GLUCOSE_VARIATION_FIELD = 'blood-glucose-variation-field',
  BLOOD_GLUCOSE_VARIATION_INPUT = 'blood-glucose-variation-input',
  BTF_FIELD = 'btf-field',
  BTF_INPUT = 'btf-input',
  BTT_FIELD = 'btt-field',
  BTT_INPUT = 'btt-input',
  CALF_CIRCUMFERENCE_FIELD = 'calf-circumference-field',
  CALF_CIRCUMFERENCE_INPUT = 'calf-circumference-input',
  CAPILLARY_BLOOD_GLUCOSE_FIELD = 'capillary-blood-glucose-field',
  CAPILLARY_BLOOD_GLUCOSE_INPUT = 'capillary-blood-glucose-input',
  CD_PAIN_SCALE_AUTOCOMPLETE = 'cd-pain-scale-autocomplete',
  CD_PAIN_SCALE_FIELD = 'cd-pain-scale-field',
  CD_PAIN_SCALE_MAPPER = 'cd-pain-scale-mapper',
  CD_PAIN_SCALE_TEXT = 'cd-pain-scale-text',
  CEPHALIC_FIELD = 'cephalic-field',
  CEPHALIC_INPUT = 'cephalic-input',
  CMB_FIELD = 'cmb-field',
  CMB_INPUT = 'cmb-input',
  CONDUCT_RECORD_AUTOCOMPLETE = 'conduct-record-autocomplete',
  CONDUCT_RECORD_FIELD = 'conduct-record-field',
  CONDUCT_RECORD_MAPPER = 'conduct-record-mapper',
  CONDUCT_RECORD_TEXT = 'conduct-record-text',
  CONTENT_PANEL = 'content-panel',
  CONTEXTUAL_BAR = 'contextual-bar',
  CRIB_TEMPERATURE_FIELD = 'crib-temperature-field',
  CRIB_TEMPERATURE_INPUT = 'crib-temperature-input',
  CUFF_PA_AUTOCOMPLETE = 'cuff-pa-autocomplete',
  CUFF_PA_FIELD = 'cuff-pa-field',
  CUFF_PA_MAPPER = 'cuff-pa-mapper',
  CUFF_PA_TEXT = 'cuff-pa-text',
  DATE_OF_WEIGHT_FIELD = 'date-of-weight-field',
  DATE_OF_WEIGHT_INPUT = 'date-of-weight-input',
  DECUBITUS_AUTOCOMPLETE = 'decubitus-autocomplete',
  DECUBITUS_FIELD = 'decubitus-field',
  DECUBITUS_MAPPER = 'decubitus-mapper',
  DECUBITUS_TEXT = 'decubitus-text',
  DEGREES_FIELD = 'degrees-field',
  DEGREES_INPUT = 'degrees-input',
  DELETE_ACTION = 'delete-action',
  DELTA_WEIGHT_FIELD = 'delta-weight-field',
  DELTA_WEIGHT_INPUT = 'delta-weight-input',
  DEVICE_PA_AUTOCOMPLETE = 'device-pa-autocomplete',
  DEVICE_PA_FIELD = 'device-pa-field',
  DEVICE_PA_MAPPER = 'device-pa-mapper',
  DEVICE_PA_TEXT = 'device-pa-text',
  DURATION_FIELD = 'duration-field',
  DURATION_INPUT = 'duration-input',
  DYNAMIC_DATA_TIME_FIELD = 'dynamic-data-time-field',
  DYNAMIC_DATA_TIME_INPUT = 'dynamic-data-time-input',
  ECG_RHYTHM_AUTOCOMPLETE = 'ecg-rhythm-autocomplete',
  ECG_RHYTHM_FIELD = 'ecg-rhythm-field',
  ECG_RHYTHM_MAPPER = 'ecg-rhythm-mapper',
  ECG_RHYTHM_TEXT = 'ecg-rhythm-text',
  FC_OXI_FIELD = 'fc-oxi-field',
  FC_OXI_INPUT = 'fc-oxi-input',
  FOCAL_SIGNAL_AUTOCOMPLETE = 'focal-signal-autocomplete',
  FOCAL_SIGNAL_FIELD = 'focal-signal-field',
  FOCAL_SIGNAL_MAPPER = 'focal-signal-mapper',
  FOCAL_SIGNAL_SPOT_AUTOCOMPLETE = 'focal-signal-spot-autocomplete',
  FOCAL_SIGNAL_SPOT_FIELD = 'focal-signal-spot-field',
  FOCAL_SIGNAL_SPOT_MAPPER = 'focal-signal-spot-mapper',
  FOCAL_SIGNAL_SPOT_TEXT = 'focal-signal-spot-text',
  FOCAL_SIGNAL_TEXT = 'focal-signal-text',
  FORM = 'form',
  FORM_PANEL = 'form-panel',
  FRAGMENT_INFORMATION_BAR_HEADER = 'fragment-information-bar-header',
  FREQUENCY_AUTOCOMPLETE = 'frequency-autocomplete',
  FREQUENCY_FIELD = 'frequency-field',
  FREQUENCY_MAPPER = 'frequency-mapper',
  FREQUENCY_TEXT = 'frequency-text',
  G_WEIGHT_FIELD = 'g-weight-field',
  G_WEIGHT_INPUT = 'g-weight-input',
  GLUCOSE_FIELD = 'glucose-field',
  GLUCOSE_INPUT = 'glucose-input',
  HEART_RATE_FIELD = 'heart-rate-field',
  HEART_RATE_INPUT = 'heart-rate-input',
  HEIGHT_CENTIMETERS_FIELD = 'height-centimeters-field',
  HEIGHT_CENTIMETERS_INPUT = 'height-centimeters-input',
  HEIGHT_METERS_FIELD = 'height-meters-field',
  HEIGHT_METERS_INPUT = 'height-meters-input',
  HEIGHT_ORIGIN_AUTOCOMPLETE = 'height-origin-autocomplete',
  HEIGHT_ORIGIN_FIELD = 'height-origin-field',
  HEIGHT_ORIGIN_MAPPER = 'height-origin-mapper',
  HEIGHT_ORIGIN_TEXT = 'height-origin-text',
  HEIGHT_UNIT_MEASURE_AUTOCOMPLETE = 'height-unit-measure-autocomplete',
  HEIGHT_UNIT_MEASURE_FIELD = 'height-unit-measure-field',
  HEIGHT_UNIT_MEASURE_MAPPER = 'height-unit-measure-mapper',
  HEIGHT_UNIT_MEASURE_TEXT = 'height-unit-measure-text',
  HIP_FIELD = 'hip-field',
  HIP_INPUT = 'hip-input',
  IE_SIDE_AUTOCOMPLETE = 'ie-side-autocomplete',
  IE_SIDE_FIELD = 'ie-side-field',
  IE_SIDE_MAPPER = 'ie-side-mapper',
  IE_SIDE_TEXT = 'ie-side-text',
  IMC_DESCRIPTION_FIELD = 'imc-description-field',
  IMC_DESCRIPTION_INPUT = 'imc-description-input',
  IMC_FIELD = 'imc-field',
  IMC_INPUT = 'imc-input',
  INATIVATE_ACTION = 'inativate-action',
  INCUBATOR_HUMIDITY_FIELD = 'incubator-humidity-field',
  INCUBATOR_HUMIDITY_INPUT = 'incubator-humidity-input',
  INCUBATOR_TEMPERATURE_FIELD = 'incubator-temperature-field',
  INCUBATOR_TEMPERATURE_INPUT = 'incubator-temperature-input',
  INEPT_REASON_PAIN_AUTOCOMPLETE = 'inept-reason-pain-autocomplete',
  INEPT_REASON_PAIN_FIELD = 'inept-reason-pain-field',
  INEPT_REASON_PAIN_MAPPER = 'inept-reason-pain-mapper',
  INEPT_REASON_PAIN_TEXT = 'inept-reason-pain-text',
  INSULIN_FIELD = 'insulin-field',
  INSULIN_INPUT = 'insulin-input',
  INTERMEDIATE_INSULIN_FIELD = 'intermediate-insulin-field',
  INTERMEDIATE_INSULIN_INPUT = 'intermediate-insulin-input',
  IRRADIATION_TOPOGRAPHY_AUTOCOMPLETE = 'irradiation-topography-autocomplete',
  IRRADIATION_TOPOGRAPHY_FIELD = 'irradiation-topography-field',
  IRRADIATION_TOPOGRAPHY_MAPPER = 'irradiation-topography-mapper',
  IRRADIATION_TOPOGRAPHY_TEXT = 'irradiation-topography-text',
  KETONE_FIELD = 'ketone-field',
  KETONE_INPUT = 'ketone-input',
  KG_WEIGHT_FIELD = 'kg-weight-field',
  KG_WEIGHT_INPUT = 'kg-weight-input',
  KIND_OF_PAIN_AUTOCOMPLETE = 'kind-of-pain-autocomplete',
  KIND_OF_PAIN_FIELD = 'kind-of-pain-field',
  KIND_OF_PAIN_MAPPER = 'kind-of-pain-mapper',
  KIND_OF_PAIN_TEXT = 'kind-of-pain-text',
  LAYOUT = 'layout',
  LEFT_EYE_LIGHT_REACTION_AUTOCOMPLETE = 'left-eye-light-reaction-autocomplete',
  LEFT_EYE_LIGHT_REACTION_FIELD = 'left-eye-light-reaction-field',
  LEFT_EYE_LIGHT_REACTION_MAPPER = 'left-eye-light-reaction-mapper',
  LEFT_EYE_LIGHT_REACTION_TEXT = 'left-eye-light-reaction-text',
  LEFT_PULLEY_SIZE_AUTOCOMPLETE = 'left-pulley-size-autocomplete',
  LEFT_PULLEY_SIZE_FIELD = 'left-pulley-size-field',
  LEFT_PULLEY_SIZE_MAPPER = 'left-pulley-size-mapper',
  LEFT_PULLEY_SIZE_TEXT = 'left-pulley-size-text',
  LEVEL_OF_CONSCIOUSNESS_AUTOCOMPLETE = 'level-of-consciousness-autocomplete',
  LEVEL_OF_CONSCIOUSNESS_FIELD = 'level-of-consciousness-field',
  LEVEL_OF_CONSCIOUSNESS_MAPPER = 'level-of-consciousness-mapper',
  LEVEL_OF_CONSCIOUSNESS_TEXT = 'level-of-consciousness-text',
  LOADER = 'loader',
  MAEC_BIS_FIELD = 'maec-bis-field',
  MAEC_BIS_INPUT = 'maec-bis-input',
  MEMBER_PA_AUTOCOMPLETE = 'member-pa-autocomplete',
  MEMBER_PA_FIELD = 'member-pa-field',
  MEMBER_PA_MAPPER = 'member-pa-mapper',
  MEMBER_PA_TEXT = 'member-pa-text',
  O2_ADDITIONAL_FIELD = 'o2-additional-field',
  O2_ADDITIONAL_INPUT = 'o2-additional-input',
  OBSTETRIC_RECORDS_BCF2_FIELD = 'obstetric-records-bcf2-field',
  OBSTETRIC_RECORDS_BCF2_INPUT = 'obstetric-records-bcf2-input',
  OBSTETRIC_RECORDS_BCF3_FIELD = 'obstetric-records-bcf3-field',
  OBSTETRIC_RECORDS_BCF3_INPUT = 'obstetric-records-bcf3-input',
  OBSTETRIC_RECORDS_FIELD = 'obstetric-records-field',
  OBSTETRIC_RECORDS_INPUT = 'obstetric-records-input',
  OBSTETRIC_RECORDS_OBSERVATION_FIELD = 'obstetric-records-observation-field',
  OBSTETRIC_RECORDS_OBSERVATION_TEXTAREA = 'obstetric-records-observation-textarea',
  ORIGIN_WIDTH_AUTOCOMPLETE = 'origin-width-autocomplete',
  ORIGIN_WIDTH_FIELD = 'origin-width-field',
  ORIGIN_WIDTH_MAPPER = 'origin-width-mapper',
  ORIGIN_WIDTH_TEXT = 'origin-width-text',
  OUTCAST_SIDE_AUTOCOMPLETE = 'outcast-side-autocomplete',
  OUTCAST_SIDE_FIELD = 'outcast-side-field',
  OUTCAST_SIDE_MAPPER = 'outcast-side-mapper',
  OUTCAST_SIDE_TEXT = 'outcast-side-text',
  PAD_FIELD = 'pad-field',
  PAD_INPUT = 'pad-input',
  PAE_MMHF_FIELD = 'pae-mmhf-field',
  PAE_MMHF_INPUT = 'pae-mmhf-input',
  PAIN_COMFORT_LEVEL_AUTOCOMPLETE = 'pain-comfort-level-autocomplete',
  PAIN_COMFORT_LEVEL_FIELD = 'pain-comfort-level-field',
  PAIN_COMFORT_LEVEL_MAPPER = 'pain-comfort-level-mapper',
  PAIN_COMFORT_LEVEL_TEXT = 'pain-comfort-level-text',
  PAIN_CONDITION_AUTOCOMPLETE = 'pain-condition-autocomplete',
  PAIN_CONDITION_FIELD = 'pain-condition-field',
  PAIN_CONDITION_MAPPER = 'pain-condition-mapper',
  PAIN_CONDITION_TEXT = 'pain-condition-text',
  PAIN_SCALE_FETCH = 'pain-scale-fetch',
  PAIN_SCALE_FIELD = 'pain-scale-field',
  PAIN_SCALE_INPUT = 'pain-scale-input',
  PAM_FIELD = 'pam-field',
  PAM_INPUT = 'pam-input',
  PANEL_LOADER = 'panel-loader',
  PANEL_SUCCESS_LOADER = 'panel-success-loader',
  PAS_FIELD = 'pas-field',
  PAS_INPUT = 'pas-input',
  PASITION_PA_FIELD = 'pasition-pa-field',
  PERFUSION_INDEX_FIELD = 'perfusion-index-field',
  PERFUSION_INDEX_INPUT = 'perfusion-index-input',
  PIA_CMH2O_FIELD = 'pia-cmh2o-field',
  PIA_CMH2O_INPUT = 'pia-cmh2o-input',
  PIA_MMHG_FIELD = 'pia-mmhg-field',
  PIA_MMHG_INPUT = 'pia-mmhg-input',
  PIC_CATHETER_TEMPERATURE_FIELD = 'pic-catheter-temperature-field',
  PIC_CATHETER_TEMPERATURE_INPUT = 'pic-catheter-temperature-input',
  PIC_MMHG_FIELD = 'pic-mmhg-field',
  PIC_MMHG_INPUT = 'pic-mmhg-input',
  PLACE_AUTOCOMPLETE = 'place-autocomplete',
  PLACE_FIELD = 'place-field',
  PLACE_MAPPER = 'place-mapper',
  PLACE_TEXT = 'place-text',
  POSITION_PA_AUTOCOMPLETE = 'position-pa-autocomplete',
  POSITION_PA_MAPPER = 'position-pa-mapper',
  POSITION_PA_TEXT = 'position-pa-text',
  PPA_MMHG_FIELD = 'ppa-mmhg-field',
  PPA_MMHG_INPUT = 'ppa-mmhg-input',
  PPC_MMHG_FIELD = 'ppc-mmhg-field',
  PPC_MMHG_INPUT = 'ppc-mmhg-input',
  PROFESSIONAL_FIELD = 'professional-field',
  PROFESSIONAL_INPUT = 'professional-input',
  PVC_CMH2O_FIELD = 'pvc-cmh2o-field',
  PVC_CMH2O_INPUT = 'pvc-cmh2o-input',
  PVC_MMHF_FIELD = 'pvc-mmhf-field',
  PVC_MMHF_INPUT = 'pvc-mmhf-input',
  RADIANCE_FIELD = 'radiance-field',
  RADIANCE_INPUT = 'radiance-input',
  RELATIONSHIP_A_Q_FIELD = 'relationship-a-q-field',
  RELATIONSHIP_A_Q_INPUT = 'relationship-a-q-input',
  RELEASE_DATE_FIELD = 'release-date-field',
  RELEASE_DATE_INPUT = 'release-date-input',
  RESPIRATORY_FREQUENCY_FIELD = 'respiratory-frequency-field',
  RESPIRATORY_FREQUENCY_INPUT = 'respiratory-frequency-input',
  RESULT_FIELD = 'result-field',
  RESULT_INPUT = 'result-input',
  RETROACTIVE_PERIOD_FIELD = 'retroactive-period-field',
  RETROACTIVE_PERIOD_INPUT = 'retroactive-period-input',
  RIGHT_EYE_LIGHT_REACTION_AUTOCOMPLETE = 'right-eye-light-reaction-autocomplete',
  RIGHT_EYE_LIGHT_REACTION_FIELD = 'right-eye-light-reaction-field',
  RIGHT_EYE_LIGHT_REACTION_MAPPER = 'right-eye-light-reaction-mapper',
  RIGHT_EYE_LIGHT_REACTION_TEXT = 'right-eye-light-reaction-text',
  RIGHT_PULLEY_SIZE_AUTOCOMPLETE = 'right-pulley-size-autocomplete',
  RIGHT_PULLEY_SIZE_FIELD = 'right-pulley-size-field',
  RIGHT_PULLEY_SIZE_MAPPER = 'right-pulley-size-mapper',
  RIGHT_PULLEY_SIZE_TEXT = 'right-pulley-size-text',
  SATURATION_CONDITION_AUTOCOMPLETE = 'saturation-condition-autocomplete',
  SATURATION_CONDITION_FIELD = 'saturation-condition-field',
  SATURATION_CONDITION_MAPPER = 'saturation-condition-mapper',
  SATURATION_CONDITION_TEXT = 'saturation-condition-text',
  SATURATION_MEMBER_AUTOCOMPLETE = 'saturation-member-autocomplete',
  SATURATION_MEMBER_FIELD = 'saturation-member-field',
  SATURATION_MEMBER_MAPPER = 'saturation-member-mapper',
  SATURATION_MEMBER_TEXT = 'saturation-member-text',
  SATURATION_O2_FIELD = 'saturation-o2-field',
  SATURATION_O2_INPUT = 'saturation-o2-input',
  SC_FIELD = 'sc-field',
  SC_INPUT = 'sc-input',
  SIDE_PUPIL_AUTOCOMPLETE = 'side-pupil-autocomplete',
  SIDE_PUPIL_FIELD = 'side-pupil-field',
  SIDE_PUPIL_MAPPER = 'side-pupil-mapper',
  SIDE_PUPIL_TEXT = 'side-pupil-text',
  ST_DERIVATION_AUTOCOMPLETE = 'st-derivation-autocomplete',
  ST_DERIVATION_FIELD = 'st-derivation-field',
  ST_DERIVATION_MAPPER = 'st-derivation-mapper',
  ST_DERIVATION_TEXT = 'st-derivation-text',
  STATUS_FIELD = 'status-field',
  STATUS_INPUT = 'status-input',
  SUCCESS_LOADER = 'success-loader',
  TEMPERATURE_FIELD = 'temperature-field',
  TEMPERATURE_INPUT = 'temperature-input',
  TEMPERATURE_UNITY_AUTOCOMPLETE = 'temperature-unity-autocomplete',
  TEMPERATURE_UNITY_FETCH = 'temperature-unity-fetch',
  TEMPERATURE_UNITY_FIELD = 'temperature-unity-field',
  TEMPERATURE_UNITY_MAPPER = 'temperature-unity-mapper',
  TEMPERATURE_UNITY_TEXT = 'temperature-unity-text',
  THORACIC_FIELD = 'thoracic-field',
  THORACIC_INPUT = 'thoracic-input',
  TIME_COURSE_AUTOCOMPLETE = 'time-course-autocomplete',
  TIME_COURSE_FIELD = 'time-course-field',
  TIME_COURSE_MAPPER = 'time-course-mapper',
  TIME_COURSE_TEXT = 'time-course-text',
  TOF_FIELD = 'tof-field',
  TOF_INPUT = 'tof-input',
  TOPOGRAPHY_AUTOCOMPLETE = 'topography-autocomplete',
  TOPOGRAPHY_FIELD = 'topography-field',
  TOPOGRAPHY_MAPPER = 'topography-mapper',
  TOPOGRAPHY_TEXT = 'topography-text',
  TRIPLE_SKIN_FOLD_FIELD = 'triple-skin-fold-field',
  TRIPLE_SKIN_FOLD_INPUT = 'triple-skin-fold-input',
  TWENTY_FOUR_HOUR_AVERAGE_FIELD = 'twenty-four-hour-average-field',
  TWENTY_FOUR_HOUR_AVERAGE_INPUT = 'twenty-four-hour-average-input',
  UM_ADDITIONAL_AUTOCOMPLETE = 'um-additional-autocomplete',
  UM_ADDITIONAL_FIELD = 'um-additional-field',
  UM_ADDITIONAL_MAPPER = 'um-additional-mapper',
  UM_ADDITIONAL_TEXT = 'um-additional-text',
  VARIATION_FIELD = 'variation-field',
  VARIATION_INPUT = 'variation-input',
  WEIGHT_UNIT_MEASURE_AUTOCOMPLETE = 'weight-unit-measure-autocomplete',
  WEIGHT_UNIT_MEASURE_FIELD = 'weight-unit-measure-field',
  WEIGHT_UNIT_MEASURE_MAPPER = 'weight-unit-measure-mapper',
  WEIGHT_UNIT_MEASURE_TEXT = 'weight-unit-measure-text',
}
export { VitalSignCreateAndEditAliases };
